"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var SmallBag = function SmallBag(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    d: "M9.5 4C9.5 3.44772 9.94772 3 10.5 3H13.5C14.0523 3 14.5 3.44772 14.5 4V4.5H17.9973V8.55959C17.9973  9.38801 17.3258 10.0596 16.4973 10.0596H7.50049C6.67206 10.0596 6.00049 9.38801 6.00049  8.55959V4.5H9.5V4ZM13.5 4V4.5H10.5V4H13.5ZM6 18.5V19C6 19.8284 6.67157 20.5 7.5  20.5H16.5C17.3284 20.5 18 19.8284 18 19L18 18.5H19C19.5523 18.5 20 18.0523 20 17.5V14.5C20  13.9477 19.5523 13.5 19 13.5H18V10.5578C17.5817 10.8728 17.0613 11.0596 16.4973  11.0596H13.8359V12.6484H10.1644V11.0596H7.50049C6.93747 11.0596 6.41791 10.8735 6  10.5594V13.5H5C4.44772 13.5 4 13.9477 4 14.5V17.5C4 18.0523 4.44772 18.5 5 18.5H6ZM6  17.5V18.5H18V17.5H6ZM11.1644 11.0596H12.8359V11.6484H11.1644V11.0596Z",
    fill: "#212124"
  }, colorStyles)));
};
SmallBag.propTypes = _inline_svg2.default.propTypes;
SmallBag.defaultProps = _inline_svg2.default.defaultProps;
var _default = SmallBag;
exports.default = _default;